import React from "react";
import ComingSoon from "../../components/ComingSoon";

const DataCollectionHub = () => {
  return (
    <ComingSoon
      title="Data Collection Hub"
      description="Centralized hub for collecting and managing all your ESG data from various sources."
      icon="📊"
    />
  );
};

export default DataCollectionHub; 